import { Controller } from "stimulus";
import {ContactsDropdown} from '../contacts_dropdown';
import GlobalOverlayManager from "../global_overlay_manager"


export default class extends Controller {

  static targets = [
    "saveButton",
    "newOverlayRadio",
    "existingOverlayRadio",
    "overlayNameInput",
    "polygonCheckbox",
    "overlayList",
    "overlayName",
    "overlaySelect",
    "publicOverlayCheckbox"
  ]

  shieldsUp = false
  shieldTimeout = null
  availableOverlays = []
  selectedOverlayData = null

  connect() {
    window.activeOverlayController = this
    this.preloadOverlayData()
    this.validate()
  }

  disconnect() {
    window.activeOverlayController = null
  }

  async preloadOverlayData() {
    // Preload overlay data when the modal connects to avoid delays during user interaction
    try {
      const response = await fetch('/search/overlays/my?page=1&limit=1000&nohtml=true', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        this.availableOverlays = data.data || [];
        this.availableOverlays
        console.log(`Preloaded ${this.availableOverlays.length} overlays`);
      } else {
        console.error('Failed to preload overlay data:', response.statusText);
        this.availableOverlays = [];
      }
    } catch (error) {
      console.error('Error preloading overlay data:', error);
      this.availableOverlays = [];
    }
  }

  populateOverlaySelect() {
    // Clear existing options
    if (!this.hasOverlaySelectTarget) return;

    this.overlaySelectTarget.innerHTML = '';

    // Add overlays to select
    this.availableOverlays.forEach(overlay => {
      const option = document.createElement('option');
      option.value = overlay.Id;
      option.textContent = overlay.Name;
      this.overlaySelectTarget.appendChild(option);
    });

    // Add event listener for selection changes
    this.overlaySelectTarget.addEventListener('change', this.onOverlaySelected.bind(this));
  }

  async onOverlaySelected(event) {
    const selectElement = event.target;
    if (!selectElement.value) {
      this.validate();
      return;
    }

    const overlayId = selectElement.value;
    try {
      // Load the selected overlay into GlobalOverlayManager memory
      let overlay = await GlobalOverlayManager.getMyMapOverlay(overlayId);
      if (overlay) {
        this.validate();
      }
    } catch (error) {
      console.error('Error loading selected overlay:', error);
    }
    this.validate();
  }

  validate() {
    if (this.newOverlayRadioTarget.checked) {
      // Validation for new overlay
      if (this.overlayNameInputTarget.value.trim() === '') {
        this.saveButtonTarget.disabled = true
        return
      }

      if (!this.polygonCheckboxTargets.some(checkbox => checkbox.checked)) {
        this.saveButtonTarget.disabled = true
        return
      }

      this.saveButtonTarget.disabled = false;
    } else if (this.existingOverlayRadioTarget.checked) {
      // Validation for existing overlay
      if (!this.hasOverlaySelectTarget || !this.overlaySelectTarget.value) {
        this.saveButtonTarget.disabled = true
        return
      }

      if (!this.polygonCheckboxTargets.some(checkbox => checkbox.checked)) {
        this.saveButtonTarget.disabled = true
        return
      }

      this.saveButtonTarget.disabled = false;
    } else {
      this.saveButtonTarget.disabled = true
    }
  }

  changeOverlayType(evt) {
    if (evt.target.value === 'Existing') {
      this.overlayListTarget.classList.remove('hidden')
      this.overlayNameTarget.classList.add('hidden')
      this.publicOverlayCheckboxTarget.parentElement.classList.add('hidden')
      // Populate the select when switching to existing overlay mode
      this.populateOverlaySelect()
    } else {
      this.overlayListTarget.classList.add('hidden')
      this.overlayNameTarget.classList.remove('hidden')
      this.publicOverlayCheckboxTarget.parentElement.classList.remove('hidden')
    }
    this.validate()
  }

  saveOverlay(evt) {
    evt.preventDefault()

    if (this.newOverlayRadioTarget.checked) {
      this.createANewOverlay()
    } else if (this.existingOverlayRadioTarget.checked) {
      this.updateExistingOverlay()
    }
  }

  updateExistingOverlay() {
    // User selected an existing overlay and we are updating it
    if (!this.overlaySelectTarget.value) {
      console.error('No overlay data selected for update');
      return;
    }

    let jsonData = {}
    jsonData['cmd'] = "srv+srch_rs/saveMapOverlay.json"
    jsonData['command_line_mode'] = true
    jsonData['modal_overlaysave_type'] = "existing"
    jsonData['modal_overlay_sel'] = this.overlaySelectTarget.value
    jsonData['modal_overlay_name'] = ''

    let polygonCount = 0
    // For each item that is checked
    this.polygonCheckboxTargets.forEach((checkbox, index) => {
      if (checkbox.checked) {
        polygonCount++;
        jsonData[`selected${polygonCount}`] = "Y";
        jsonData[`label${polygonCount}`] = $(`[name="label${index + 1}"]`).val();
        jsonData[`color${polygonCount}`] = $(`[name="color${index + 1}"]`).val();
        jsonData[`coords${polygonCount}`] = $(`[name="coords${index + 1}"]`).val();
      }
    });

    jsonData['polyCount'] = polygonCount

    // Use GlobalOverlayManager singleton to update the existing overlay
    GlobalOverlayManager.updateExistingMyMapOverlay(jsonData)
  }

  createANewOverlay() {
    // User filled out the form and we are creating a new overlay.
    let jsonData = {}
    if (this.newOverlayRadioTarget.checked) {
      jsonData['cmd'] = "srv+srch_rs/saveMapOverlay.json"
      jsonData['command_line_mode'] = true
      jsonData['modal_overlaysave_type'] = "new"
    }

    jsonData['public'] = this.publicOverlayCheckboxTarget.checked ? 'Y' : 'N'
    jsonData['modal_overlay_name'] = this.overlayNameInputTarget.value.trim()

    let polygonCount = 0
    // For each item that is checked
    this.polygonCheckboxTargets.forEach((checkbox, index) => {
      if (checkbox.checked) {
        polygonCount++;
        jsonData[`selected${polygonCount}`] = "Y";
        jsonData[`label${polygonCount}`] = $(`[name="label${index + 1}"]`).val();
        jsonData[`color${polygonCount}`] = $(`[name="color${index + 1}"]`).val();
        jsonData[`coords${polygonCount}`] = $(`[name="coords${index + 1}"]`).val();
      }
    });

    jsonData['polyCount'] = polygonCount
    GlobalOverlayManager.createNewMyMapOverlay(jsonData)
  }

  cancelChanges(evt) {
    console.log("Overlay Editor Modal Controller: cancelChanges action placeholder")
  }

  activateTimeShield(evt) {
    console.log('timeshield!')
    // cancel any shields that are currently happening
    clearTimeout(this.shieldTimeout)

    // Chewy, divert auxillary power to the deflector shields!
    this.shieldsUp= true

    this.shieldTimeout = setTimeout(() => {
      // Chewbacca: Aaaarrrgh!
      this.shieldsUp = false
    }, 500)
  }

}
